import { Component } from '@angular/core';
import { HeaderNavbarWrapperComponent as BaseComponent } from '../../../../app/header-nav-wrapper/header-navbar-wrapper.component';
import { slideMobileNav } from '../../../../app/shared/animations/slide';
import { WidthCategory } from '../../../../app/shared/host-window.service';

@Component({
  selector: 'ds-header-navbar-wrapper',
  styleUrls: ['header-navbar-wrapper.component.scss'],
  templateUrl: 'header-navbar-wrapper.component.html',
  animations: [slideMobileNav],
})
export class HeaderNavbarWrapperComponent extends BaseComponent {
  // Show collapsible mobile nav up to MD; desktop band shows from MD+ via d-md-block
  maxMobileWidth = WidthCategory.SM;
}
